import { configureStore } from '@reduxjs/toolkit';

import { rtkApi } from '@/apis/rtkApi';
import counterReducer from './slices/counterSlice';
import guidedModeReducer from './slices/guidedModeSlice';
import hybridInterestRateReducer from './slices/hybridInterestRateSlice';
import interestRateReducer from './slices/interestRateSlice';
import modeReducer from './slices/modeSlice';
import propertyUiReducer from './slices/propertyUiSlice';
import refinanceReducer from './slices/refinanceSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    interestRate: interestRateReducer,
    hybridInterestRate: hybridInterestRateReducer,
    guidedMode: guidedModeReducer,
    mode: modeReducer,
    propertyUi: propertyUiReducer,
    refinance: refinanceReducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
